const BASE_URL = "api/logging";
//import AppInsights from "applicationinsights-js";
import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


export const logReactError = (errorMsg, errorInfo) => {
    try {
        console.error(errorMsg);
        const fullUrl = `${BASE_URL}/LogError`;
        const payload = { Error: errorMsg.toString(), Info: JSON.stringify(errorInfo) };

        const params = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json"
            },
            body: JSON.stringify(payload), 
            withCredentials: true
        };

        const start = new Date();

        fetch(fullUrl, params).then(resp => {
            logAPI("MBHWeb.Api.LogError.Post", start, fullUrl);
            return resp;
        }).catch(err => { logAPI("MBHWeb.Api.LogError.Post.Failure", start, fullUrl, err); return Promise.reject(err); });
    }
    catch (ex) {
        logAPI("MBHWeb.Api.LogError.Post.Failure", new Date(), `${BASE_URL}/LogError`, ex);
    }

};
